module.exports = "https://static.energy5.com/_next/static/images/ledsBg-ccd07dfe347e8b8edc901132182b2846.webp";